import { useMemo } from 'react'

export const formatTimeFromSeconds = (time: number): string => {
  // Если значение > 86400 (секунд в сутках), то это миллисекунды
  const seconds = time > 86400 ? Math.floor(time / 1000) : time
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  return `${formattedHours}:${formattedMinutes}`
}

const useShopTime = (openTime: number, closeTime: number) => {
  // Нормализуем время в секунды
  const openSeconds = openTime > 86400 ? Math.floor(openTime / 1000) : openTime
  const closeSeconds = closeTime > 86400 ? Math.floor(closeTime / 1000) : closeTime

  const { open, close } = useMemo(() => {
    const open = formatTimeFromSeconds(openTime)
    const close = formatTimeFromSeconds(closeTime)
    return { open, close }
  }, [ openTime, closeTime ])

  const getShopStatus = useMemo(() => {
    const now = new Date()
    const currentTimeInSeconds = now.getHours() * 3600 + now.getMinutes() * 60
    return currentTimeInSeconds >= openSeconds && currentTimeInSeconds < closeSeconds
  }, [ openSeconds, closeSeconds ])

  return { open, close, getShopStatus }
}

export default useShopTime
